/*
 * Public API Surface of angular-emojis
 */

export * from './lib/angular-emojis.service';
export * from './lib/angular-emojis.component';
export * from './lib/angular-emojis.module';
